import React, { Fragment, useState } from "react";
import { Row, Col } from "antd";
import { Link } from "react-router-dom";
import RuleModal from "../modal/RuleModal";
import { KEYS } from "../../Config/Keys";
import { DownloadOutlined } from "@ant-design/icons";

const About = ({ data, rulesAndRegulations }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const truncateText = (text, limit = 20) => {
    if (!text || text.length <= limit) return text;
    return text.substring(0, limit) + "...";
  };

  return (
    <Fragment>
      <Row className="sideItem">
        <Col span={24}>
          <h1 className="timelineAboutpadding">About</h1>
          <p className="timelinedesc">
            {data?.description ||
              `
                It is a long established fact that a reader will be distracted by  the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using
                 `}
          </p>
          <p className="timelineiconpadding flexcenter">
            <img src="/images/icons/2people.png" className="timelineiconplacecenter" alt="" />

            <span className="sideItemsText">
              {data?.registerteams?.length === 1
                ? data?.registerteams?.length + " Team "
                : data?.registerteams?.length + "  Teams are "}
              Registered.
            </span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img src="/images/icons/peoples.png" className="timelineiconplacecenter" alt="" />

            <span className="sideItemsText">
              Event by{" "}
              <Link
                state="panel"
                to={`/view/panel/${data?.panel?._id}/timeline`}
                className="boldBlueColor">
                {data?.panel?.name}
              </Link>
            </span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img src="/images/icons/location.png" className="timelineiconplacecenter" alt="" />

            <span className="sideItemsText">{data?.location}</span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img src="/images/icons/money.png" className="timelineiconplacecenter" alt="" />

            <span className="sideItemsText">
              {data?.fee !== 0 ? (
                <span>{data?.fee} Rs per Team</span>
              ) : (
                <span>Free Registration</span>
              )}
            </span>
          </p>
          <p className="timelineiconpadding flexcenter">
            <img src="/images/icons/aboutcalender.png" className="timelineiconplacecenter" alt="" />
            <span
              className="sideItemsText timelinetopcolor"
              style={{ display: "flex", gap: ".3rem" }}>
              <span>{new Date(data?.startDate).toDateString()}</span>-
              <span>{new Date(data?.endDate).toDateString()}</span>
            </span>
          </p>
          {(rulesAndRegulations?.file || rulesAndRegulations?.text) && (
            <div className="rules-section">
              <h3 className="timelineAboutpadding">Rules and Regulations</h3>
              <div className="timelinedesc" style={{ display: "flex", alignItems: "center" }}>
                <span>{truncateText(rulesAndRegulations?.text)}</span>
                {rulesAndRegulations?.text.length > 20 && (
                  <span
                    className="show-more-link"
                    style={{ color: "#1890ff", marginLeft: "8px", cursor: "pointer" }}
                    onClick={() => {
                      setIsModalVisible(true);
                    }}>
                    Show More
                  </span>
                )}
              </div>
              {rulesAndRegulations?.file?.fileUrl && (
                <a
                  href={KEYS.API + rulesAndRegulations?.file?.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rules-link ml-2"
                  style={{
                    display: "inline-block",
                    padding: "8px 16px",
                    backgroundColor: "#1890ff",
                    color: "#fff",
                    borderRadius: "4px",
                    textDecoration: "none",
                    marginTop: "8px",
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}>
                  <DownloadOutlined style={{ marginRight: "8px" }} />
                  {truncateText(rulesAndRegulations?.file?.fileName || "Event Rules", 15)}
                </a>
              )}
            </div>
          )}
        </Col>
      </Row>
      <RuleModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        rule={rulesAndRegulations}
      />
    </Fragment>
  );
};

export default About;
